import { render } from "./QRcode.vue?vue&type=template&id=21ac1d7e"
import script from "./QRcode.vue?vue&type=script&lang=js"
export * from "./QRcode.vue?vue&type=script&lang=js"
script.render = render

export default script